export default {
  title: 'Kontakt Info',
  form: {
    customer_first_name: {
      placeholder: 'Vornamen',
    },
    customer_last_name: {
      placeholder: 'Nachname',
    },
    customer_email: {
      placeholder: 'Email Adresse',
    },
    customer_phone_number: {
      placeholder: 'Rufnummer',
    },
  },
  validation: {
    customer_first_name: {
      required: 'Bitte geben Sie Ihren Vornamen ein',
    },
    customer_last_name: {
      required: 'Bitte geben Sie Ihren Nachnamen ein',
    },
    customer_email: {
      required: 'Bitte geben Sie Ihre Email ein',
    },
    customer_phone_number: {
      required: 'Bitte geben Sie Ihre Rufnummer ein',
    },
  },
};
